import { CoreLayoutView, CoreTextView, ORIENTATION_ENUM } from '@core/widgets';
import React from 'react';
import { TextStyle } from '../../../types/styles';

type TFeeBlockProps = {
    title?: string;
    text?: string;
    textColor?: string;
    rate?: string;
    icon?: React.ReactNode;
    parentStyleNames?: string[];
};

const FeeBlock = React.memo(({ title, text, rate, icon, textColor, parentStyleNames }: TFeeBlockProps) => {
    const subtitleColor = textColor ? textColor : 'var(--color-black)';
    return (
        <CoreLayoutView
            styleName="calculatorInfoCellColumn"
            parentStyleNames={parentStyleNames}
            styleProps={{ orientation: ORIENTATION_ENUM.VERTICAL, lineX: 'center', lineY: 'center', gap: 8 }}
        >
            <CoreLayoutView
                styleName="calculatorInfoCellSubtitleRow"
                parentStyleNames={parentStyleNames}
                styleProps={{ orientation: ORIENTATION_ENUM.HORIZONTAL, lineX: 'center', lineY: 'center', height: 28 }}
            >
                <CoreTextView
                    text={title}
                    styleName="calculatorInfoTitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.secondary,
                        main: 'var(--color-grey_72_lc)',
                        textAlign: 'center',
                    }}
                />
                {icon}
            </CoreLayoutView>
            <CoreLayoutView styleProps={{ orientation: ORIENTATION_ENUM.HORIZONTAL, lineX: 'center', lineY: 'center', height: 28 }}>
                <CoreTextView
                    text={text}
                    styleName="calculatorInfoSubtitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.secondary,
                        textAlign: 'center',
                        main: subtitleColor,
                        margin: { right: 3 },
                    }}
                />
                <CoreTextView
                    text={rate?.toUpperCase()}
                    styleName="calculatorInfoSubtitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.secondary,
                        textAlign: 'center',
                        main: subtitleColor,
                    }}
                />
            </CoreLayoutView>
        </CoreLayoutView>
    );
});

export { FeeBlock };
